import { Box, IconButton, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  PageBar,
  SSPCommonTable,
  SSPCommonButton,
  SSPCommonVideo,
} from "../../../CommonComponents";
import { Download } from "@mui/icons-material";
import AWS from "aws-sdk";
import SSPCommonModal from "../../../CommonComponents/SSPCommonModal/SSPCommonModal";
import * as FileSaver from "file-saver";
import Tooltip from "@mui/material/Tooltip";
import { useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button,
  Grid,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import axios from "axios"; // Import axios for making HTTP requests
import Cookies from "js-cookie";
import { post } from "../../../services";
import styles from "./style.module.css";
const base = "https://";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

// Function to upload file using presigned URL
const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
  try {
    const fileUploadData = new FormData();
    Object.keys(generatedUrl.fields).forEach((key) => {
      fileUploadData.append(key, generatedUrl.fields[key]);
    });
    fileUploadData.append("file", filetoUpload);

    const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);

    if (fileUploaded) {
      return true;
    } else {
      // console.error("File upload failed");
      return false;
    }
  } catch (error) {
    // console.error("Error during file upload:", error);
    throw error;
  }
};

// Function to make HTTP request for file upload
const uploadFile = async (url, formData) => {
  try {
    const response = await axios.post(url, formData);

    if (response.status === 204) {
      // console.log('File upload successful with status 204');
      return true;
    }

    if (response.status >= 200 && response.status < 300) {
      // console.log('File upload successful');
      return true;
    } else {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  } catch (error) {
    // console.error('Error during file upload:', error);
    throw error;
  }
};
const UploadInvoice = ({ token }) => {
  const id = Cookies.get("ssp_domain_id");
  // console.log(" UploadInvoice ID:", id);
  // console.log("UploadInvoice token:", token);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [modalOpener, setmodalOpener] = useState(false);
  const [message, setmessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [vendorName, setVendorName] = useState("");

  const handleFileSelect = (e, startDate, endDate, location, total_cost) => {
    const file = e.target.files[0];
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    if (!allowedTypes.includes(file.type)) {
      // Show a pop-up or error message here
      setmessage("Only PDF and image files (JPEG, JPG, PNG) are allowed.");
      setmodalOpener(true);
      return;
    }
    const newFile = {
      file: e.target.files[0],
      billingCycle: { startDate, endDate },
      location,
      total_cost,
    };
    setSelectedFiles((prevFiles) => [...prevFiles, newFile]);
  };

  const ExcelJS = require("exceljs");
  // to download customer master

  const HoverCell = ({ value }) => {
    return (
      <Tooltip title={value}>
        <div style={{ whiteSpace: "normal", textAlign: "start" }}>{value}</div>
      </Tooltip>
    );
  };

  const handleFileUpload = async () => {
    if (selectedFiles.length === 0) {
      setmessage("Please select a file to upload.");
      setmodalOpener(true);
      return;
    }

    try {
      setLoading(true);
      for (const fileData of selectedFiles) {
        const { file, billingCycle, location, total_cost } = fileData;
        // Step 1: Get the presigned URL
        const presignedUrlResponse = await post(
          base +
            "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/gen_pre_url",
          {
            doc_type: "invoice",
            doc_name: file.name,
          },
          true,
          false
        );
        const presignedUrl = presignedUrlResponse?.body;

        // Step 2: Upload the file to the presigned URL
        const fileUploaded = await uploadFileWithPresignedUrl(
          file,
          presignedUrl
        );

        if (fileUploaded) {
          // console.log("File upload successful");

          const invoiceUploadResponse = await post(
            base +
              "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/upload_invoice",
            {
              file_name: file.name,
              user_name: parseInt(id),
              billing_start_date: billingCycle.startDate,
              billing_end_date: billingCycle.endDate,
              loc: location,
              total_cost: total_cost,
            },
            true,
            false
          );
        }
        setmessage("File upload successful!");
        setmodalOpener(true);
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
    } catch (error) {
      // console.error("Error during file upload:", error);
      setmessage("Error during file upload. Please try again.");
      setmodalOpener(true);
    } finally {
      setLoading(false);
      setSelectedFiles([]);
    }
  };
  // const fetchData = async () => {
  //   try {
  //     const response = await axios.functionURLService("hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/vendor_invoices");
  //     if (response.data && response.data.length > 0) {
  //       setVendorName(response.data.data[0].vendor_name);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const columns = [
    { field: "id", headerName: "Sl.no", flex: 1 },
    {
      field: "",
      headerName: "Billing Cycle",
      flex: 1,
      wrapText: true,
      renderCell: (params) => {
        const row = params.row;
        const dateRange = `${row.billing_start_date} to ${row.billing_end_date}`;
        return <HoverCell value={dateRange} />;
      },
    },
    {
      field: "loc_name",
      headerName: "Location",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "modified_date",
      headerName: "Uploaded On",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "invoice_doc",
      headerName: "Invoice",
      type: "number",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          disabled={loading || params.row.status === "Error"}
          onClick={() => downloadFinalInvoiceFile(params.row.invoice_doc)}
        >
          <Download
            color={params.row.status === "Error" ? "grey" : "primary"}
          />
        </IconButton>
      ),
    },
  ];

  const downloadFinalInvoiceFile = async (fileName) => {
    try {
      // Step 1: Get the presigned URL from the server
      const presignedUrlResponse = await post(
        base +
          "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/get_doc_url",
        {
          doc_type: "invoice",
          doc_name: fileName,
        },
        true,
        false
      );
      // console.log("first Presigned URL:", presignedUrlResponse);

      const presignedUrl = presignedUrlResponse.data;
      // console.log("Download Presigned URL:", presignedUrl);

      if (!presignedUrl) {
        // console.error('Error: Empty presigned URL');
        return;
      }

      // Step 2: Use the presigned URL to download the file
      if (presignedUrlResponse.status === "success") {
        window.open(presignedUrl, "_blank");
      } else {
        setmessage(presignedUrlResponse.body.message);
        setmodalOpener(true);
      }
    } catch (error) {
      // console.error('Error during file download:', error);
    }
  };

  const DownloadExcelSheet = async (response, fileName) => {
    if (response !== null) {
      let data = response;
      data[0]["date"] = Date();
      const workbook = new ExcelJS.Workbook();
      const headers = Object.keys(data[0]);
      const worksheet = workbook.addWorksheet("data");
      const firstRow = worksheet.getRow(1);
      for (let i = 1; i <= headers.length; i++) {
        const cell = firstRow.getCell(i);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFA500" },
        };
      }
      worksheet.columns = headers.map((header) => ({ header, key: header }));
      data.forEach((dataRow) => {
        worksheet.addRow(dataRow);
      });
      worksheet.columns.forEach((column) => {
        column.width = 25;
      });
      workbook.xlsx.writeBuffer().then((buffer) => {
        const data = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(data, fileName + ".xlsx");
      });
    } else {
      setmessage("No data provided to download the file");
      setmodalOpener(true);
    }
  };
  const [invoiceData, setInvoiceData] = useState([]);
  const [generated, setGenerated] = useState(false);
  const [selectedBillingCycle, setSelectedBillingCycle] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectedlocation, setSelectedlocation] = useState({ location: "" });

  const generateInvoices = async () => {
    try {
      const response = await post(
        base +
          "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/vendor_summary",
        {
          vendor_id: id,
        },
        true,
        false
      );
      if (response) {
        // console.log("API Response:", response);
        if (response?.status === "error") {
          // console.error("error API Response:", response?.status);
          setmessage("Error : " + response?.error_message);
          setmodalOpener(true);
        } else {
          setInvoiceData(response);
          setGenerated(true);
        }
      }
    } catch (error) {
      // console.error("Error fetching invoice table data:", error);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#EEF2F7",
      }}
    >
      {/* Page Bar */}
      <PageBar
        text="Transport Billing : Upload Invoice"
        vendorId={id?.toString()}
      />

      <Card
        sx={{
          backgroundColor: "#EEF2F7",
          padding: "1.3rem",
        }}
      >
        <CardHeader
          p={2}
          sx={{
            backgroundColor: "#F8F8F9",
            fontWeight: "700",
            borderTopRightRadius: "5px",
            borderTopLeftRadius: "5px",
          }}
          title={"Costing Summary and Invoice Upload"}
          titleTypographyProps={{
            sx: {
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "16px",
              color: "#0160F1",
            },
          }}
        />
        <Divider />
        <CardContent
          sx={{
            backgroundColor: "#FFFFFF",
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
            // marginBottom: -5
          }}
        >
          <Box
            sx={{
              display: { lg: "flex", bgcolor: "red" },
            }}
          >
            {/* Generate Invoice Button */}
            <Button

              onClick={generateInvoices}
              disabled={generated}
              size="small"
              className={styles.generateCostButton}

            >
              Generate Costing Summary
            </Button>
          </Box>
          <Box
            sx={{
              display: { lg: "flex", bgcolor: "red" },
            }}
          >
            {generated && (
              <Card
                sx={{
                  marginTop: "20px",
                  backgroundColor: "#FFFFFF",
                  padding: "1rem",
                  width: "100%",
                }}
              >
                <TableContainer sx={{ width: "100%" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Billing Cycle
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Location
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Costing
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Upload Invoice
                          <span style={{ fontSize: "smallest", color: "grey" }}>
                            {" "}
                            (Please upload invoice as a PDF/image)
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoiceData.data.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{`${row.billing_start_date} to ${row.billing_end_date}`}</TableCell>
                          <TableCell>{row.location_name}</TableCell>
                          <TableCell>
                            {row.total_cost || "N/A, Please accept all Trips"}
                          </TableCell>
                          <TableCell>
                            {row.total_cost ? (
                              <input
                                type="file"
                                onChange={(e) =>
                                  handleFileSelect(
                                    e,
                                    row.billing_start_date,
                                    row.billing_end_date,
                                    row.location_name,
                                    row.total_cost
                                  )
                                }
                              />
                            ) : (
                              <span>{row.msg || "Not Available"}</span>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box marginTop={3}>
                  <SSPCommonButton
                    btnText={"SAVE DATA"}
                    btnFunction={handleFileUpload}
                    loading={loading}
                  />
                </Box>
              </Card>
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Table  */}
      <SSPCommonTable
        headerTitle={"Past Invoices"}
        columnTable={columns}
        functional_url="hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws"
        table_data_function_name="/vendor_invoices"
        download_file_name="invoice_download"
        row_data_function_name="/process_log"
        user_id={id}
      />
      {/* Video  */}
      <SSPCommonVideo
        headerText={"Demo Video"}
        videoUrl={
          "https://www.youtube.com/embed/OXOuPx2DErA?si=Vx8VM0qBMCzb4NnV"
        }
      />
      {modalOpener && (
        <SSPCommonModal
          open={modalOpener}
          handleOpenClose={setmodalOpener}
          message={message}
        />
      )}
    </Box>
  );
};

export default UploadInvoice;
